import React, { useEffect } from 'react'
import * as TYPES from './types'

const PublicContainer: React.FC<TYPES.PublicContainerProps> = ({ children, ...props }) => {
    useEffect(() => {
        document.body.classList.add('gn-public-container');
        return () => { document.body.classList.remove('gn-public-container'); };
    }, []);

    return (
        <div className="gn-public">
            {children}
        </div>
    );
}
export default PublicContainer